module.exports = __webpack_public_path__ + "static/media/gls.a5ed6d06.png";